// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3185":"58636581","3278":"f58fd286","6483":"406090c0","8003":"3916ab1b","9127":"b6d2d26d"}[chunkId] + ".chunk.css";
};